import { render, staticRenderFns } from "./repairStatistics.vue?vue&type=template&id=7484e572&scoped=true&"
import script from "./repairStatistics.vue?vue&type=script&lang=js&"
export * from "./repairStatistics.vue?vue&type=script&lang=js&"
import style0 from "./repairStatistics.vue?vue&type=style&index=0&id=7484e572&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7484e572",
  null
  
)

export default component.exports